import React, { useState, useEffect } from 'react';
import { Container, Paper, TextField, Button, Box, FormControlLabel, Checkbox, Alert } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api/axiosConfig';

const SectorForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const user = localStorage.getItem('user');

  const [formData, setFormData] = useState({
    codigo: '',
    descripcion: '',
    observaciones: '',
    activo: true,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (id) {
      api.get(`/sectores/${id}/`).then(res => setFormData(res.data));
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const payload = {
      ...formData,
      creado_por: user,
      modificado_por: user,
    };

    try {
      if (id) {
        await api.put(`/sectores/${id}/`, { ...formData, modificado_por: user });
      } else {
        await api.post('/sectores/', payload);
      }
      navigate('/sectores');
    } catch (err) {
      setError('Error al guardar el sector');
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 3, mt: 3 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label="Código *"
            fullWidth
            value={formData.codigo}
            onChange={(e) => setFormData({ ...formData, codigo: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            label="Descripción *"
            fullWidth
            value={formData.descripcion}
            onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            label="Observaciones"
            fullWidth
            multiline
            rows={3}
            value={formData.observaciones}
            onChange={(e) => setFormData({ ...formData, observaciones: e.target.value })}
            margin="normal"
          />
          <FormControlLabel
            control={<Checkbox checked={formData.activo} onChange={(e) => setFormData({ ...formData, activo: e.target.checked })} />}
            label="Activo"
          />
          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
          <Box sx={{ mt: 2 }}>
            <Button type="submit" variant="contained" disabled={loading} sx={{ mr: 1 }}>
              {loading ? 'Guardando...' : id ? 'Actualizar' : 'Crear'}
            </Button>
            <Button onClick={() => navigate('/sectores')}>Cancelar</Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default SectorForm;